// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","list":"_18kT-","listItem":"_28E0i","orderedList":"Q47HW","unorderedList":"_2nWTg"};